import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HomeIcon from '@material-ui/icons/Home';
import PrintIcon from '@material-ui/icons/Print';
import HelpIcon from '@material-ui/icons/Help';
import RecommendationRequest from '../../Recommendations/RequestRecommendation';
import RecommendationIcon from '../../../assets/img/planner-recommendations-icon.svg';
import { useReactToPrint } from 'react-to-print';
import AboutMe from '../../Recommendations/AboutMe';
import { isStudent, isAlumni, isAdminOrFHT } from '../../../util/miscUtil';

const Recommendation = ({
  senior,
  alumni,
  roles,
  handleHelp,
  store,
  auth,
  handleAfterSaveReturn,
  setPage,
  handleReturnToSeniorList,
  fetchRecommendations,
  classes,
  handleAfterAboutMeUpdate,
  handleGotoAdminHomepage,
}) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [form, setForm] = React.useState({
    created_at: null,
    email: '',
    expires_utc: null,
    first_name: '',
    last_date_requested: null,
    last_name: '',
    recommendation_id: 0,
    salutation: '',
    scholarship_app_created: null,
    scholarship_app_id: 0,
    status: 'created',
    student_first_name: '',
    student_id: 0,
    student_last_name: '',
    token: '',
    updated_at: null,
    version: 2,
  });

  const [formExtra, setFormExtra] = React.useState({
    relationship: '',
    scholarships: false,
    tradeLife: false,
    housing: false,
  });
  const status = form.status;
  const isEditDisabled = () => {
    return status === 'Requested' || status === 'Re-Requested' || status === 'Expired' || status === 'Complete';
  };
  const isEditAboutMeDisabled = () => {
    if (isAdminOrFHT(roles)) {
      return true;
    }
    return false;
  };
  return (
    <React.Fragment>
      {!isStudent(roles) && !isAlumni(roles) && (
        <div className={classes.breadcrumbs}>
          <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-2px' }} onClick={(e) => handleGotoAdminHomepage()}>
              <HomeIcon style={{ fontSize: '1.30rem' }} />
              <span style={{ margin: '1px 0 0 1px' }}>Home</span>
            </span>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
              {alumni ? 'Alumni' : 'High School Seniors'}
            </span>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
              {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
              {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
            </span>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('recommendationlist')}>
              Letters of Recommendation
            </span>
            <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
              Recommendation
            </span>
          </Breadcrumbs>
        </div>
      )}
      <Grid container spacing={2} direction="row" className={classes.oldStyleMenu} ref={componentRef}>
        <Grid item xs={12} align="left" className={classes.unprintedContent}>
          <Card className={classes.pageHeader}>
            <CardBody>
              <Grid container direction="row">
                <Grid item xs={10} align="left">
                  <section className={classes.oldStylePageTitle}>
                    <img src={RecommendationIcon} alt="Recommendation Icon" className={classes.pageIcon} />
                    <span>Letter of Recommendation Request</span>
                  </section>
                  <aside className={classes.headerDesc}>Complete the request for a letter of recommendation.</aside>
                </Grid>
                <Grid item xs={2} align="right">
                  <Tooltip title="Click to return to the planner home page." placement="bottom">
                    <IconButton color="inherit" aria-label="return home" onClick={(e) => setPage('home')}>
                      <HomeIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to open the printer dialog." placement="bottom">
                    <IconButton color="inherit" aria-label="print scholarship application" onClick={handlePrint}>
                      <PrintIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to view printer tips & tricks." placement="bottom">
                    <IconButton color="inherit" aria-label="printer tips and tricks" onClick={handleHelp}>
                      <HelpIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} align="left" className={classes.printedContent}>
          <section className={classes.pageTitle}>
            <span className={classes.printHeaderText}>Letter of Recommendation Request</span>
          </section>
          <aside className={classes.printHeaderDesc}>Complete the request for a letter of recommendation.</aside>
        </Grid>
        <Grid item xs={12}>
          <AboutMe
            senior={senior}
            store={store}
            auth={auth}
            handleSaveReturn={fetchRecommendations}
            classes={classes}
            handleAfterAboutMeUpdate={handleAfterAboutMeUpdate}
            version={form.version}
            formExtra={formExtra}
            setFormExtra={setFormExtra}
            isEditDisabled={isEditDisabled()}
            isEditAboutMeDisabled={isEditAboutMeDisabled()}
          />
          <RecommendationRequest
            SeniorStore={store}
            AuthStore={auth}
            handleSaveReturn={fetchRecommendations}
            classes={classes}
            form={form}
            setForm={setForm}
            formExtra={formExtra}
            setFormExtra={setFormExtra}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

Recommendation.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  handleHelp: PropTypes.func,
  store: PropTypes.object,
  auth: PropTypes.object,
  handleAfterSaveReturn: PropTypes.func,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  fetchRecommendations: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleAfterAboutMeUpdate: PropTypes.func,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default Recommendation;
